import { role_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateRoleEnum = (enumValue: role_enum) => {
  switch (enumValue) {
    case role_enum.API_READ:
      return <Trans i18nKey="Enum_RoleEnum-API_READ" />;
    case role_enum.API_WRITE:
      return <Trans i18nKey="Enum_RoleEnum-API_WRITE" />;
    case role_enum.BANKING_USER:
      return <Trans i18nKey="Enum_RoleEnum-BANKING_USER" />;
    case role_enum.DANGER_PUBLIC_ROLE:
      return <Trans i18nKey="Enum_RoleEnum-DANGER_PUBLIC_ROLE" />;
    case role_enum.ORG_ADMIN:
      return <Trans i18nKey="Enum_RoleEnum-ORG_ADMIN" />;
    case role_enum.RETOOL_ADMIN:
      return <Trans i18nKey="Enum_RoleEnum-RETOOL_ADMIN" />;
    case role_enum.RETOOL_USER:
      return <Trans i18nKey="Enum_RoleEnum-RETOOL_USER" />;
    case role_enum.UNAUTHORIZED:
      return <Trans i18nKey="Enum_RoleEnum-UNAUTHORIZED" />;
    case role_enum.USER:
      return <Trans i18nKey="Enum_RoleEnum-USER" />;
    case role_enum.admin:
      return <Trans i18nKey="Enum_RoleEnum-admin" />;
  }
};

export const translateRoleEnum_dynamic = (enumValue: role_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case role_enum.API_READ:
      return t('Enum_RoleEnum-API_READ');
    case role_enum.API_WRITE:
      return t('Enum_RoleEnum-API_WRITE');
    case role_enum.BANKING_USER:
      return t('Enum_RoleEnum-BANKING_USER');
    case role_enum.DANGER_PUBLIC_ROLE:
      return t('Enum_RoleEnum-DANGER_PUBLIC_ROLE');
    case role_enum.ORG_ADMIN:
      return t('Enum_RoleEnum-ORG_ADMIN');
    case role_enum.RETOOL_ADMIN:
      return t('Enum_RoleEnum-RETOOL_ADMIN');
    case role_enum.RETOOL_USER:
      return t('Enum_RoleEnum-RETOOL_USER');
    case role_enum.UNAUTHORIZED:
      return t('Enum_RoleEnum-UNAUTHORIZED');
    case role_enum.USER:
      return t('Enum_RoleEnum-USER');
    case role_enum.admin:
      return t('Enum_RoleEnum-admin');
  }
};
